/**
 * Video-Block: startet automatisch stumm, sobald der Player zur Hälfte
 * im Viewport steht. Ein Klick aufs Poster startet stattdessen mit Ton.
 *
 * data-video           Player-Element
 * data-video-url       Video-Link aus dem ACF-Feld
 * data-video-play      Play-Button
 */

import { track } from './tracking'

const toEmbedUrl = (url, muted) => {
  const youtube = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/)
  if (youtube)
    return `https://www.youtube-nocookie.com/embed/${youtube[1]}?autoplay=1&rel=0${muted ? '&mute=1' : ''}`

  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1${muted ? '&muted=1' : ''}`

  return null
}

document.querySelectorAll('[data-video]').forEach((player) => {
  const start = (muted) => {
    if (player.classList.contains('is-playing')) return

    const embedUrl = toEmbedUrl(player.dataset.videoUrl ?? '', muted)
    if (!embedUrl) return

    const iframe = document.createElement('iframe')
    iframe.src = embedUrl
    iframe.allow = 'autoplay; fullscreen; picture-in-picture'
    iframe.allowFullscreen = true

    player.classList.add('is-playing')
    player.appendChild(iframe)

    // Poster erst überblenden, wenn der Player steht – sonst fadet man auf ein schwarzes Bild
    const reveal = () => player.classList.add('is-ready')
    let fallback = setTimeout(reveal, 2500)

    iframe.addEventListener('load', () => {
      clearTimeout(fallback)
      // Kurzer Vorlauf: YouTube/Vimeo brauchen nach dem load noch einen Moment bis zum ersten Frame
      fallback = setTimeout(reveal, 400)
    })

    // Ohne method sähe jedes Vorbeiscrollen wie ein bewusster Videostart aus
    track('video_start', {
      method: muted ? 'auto_muted' : 'click_sound',
      video_url: player.dataset.videoUrl,
    })
  }

  player.addEventListener('click', () => start(false))

  // Autoplay (stumm), sobald der Player zur Hälfte sichtbar ist
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        observer.disconnect()
        start(true)
      })
    },
    { threshold: 0.5 }
  )

  observer.observe(player)
})
